import * as tslib_1 from "tslib";
import { request } from '../../xhr';
import { call, put, all, takeEvery } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { normalize } from '../../redux/normalizr';
import { deviationSchema } from '../../redux/normalizr/schemas/deviation';
import { actions as ModalActions } from '../../Modals';
import { getDeviationUrl } from '../../DeviationViews/_helpers';
import { createPollRequest as createPollRequestAction, updatePollRequest as updatePollRequestAction, createPollSuccess as createPollSuccessAction, updatePollSuccess as updatePollSuccessAction, } from './actions';
import { editDeviationSuccess } from '../../redux/deviations/actionCreators';
function postRequest(url, data) {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'post',
                    url: url,
                    data: data,
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}
export function createPollRequestSaga(action) {
    var payload, params, response, normalizedDeviation;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                params = {
                    question: payload.question,
                    answers: payload.answers,
                };
                return [4 /*yield*/, call(postRequest, '/poll/create', params)];
            case 1:
                response = _a.sent();
                if (!(response && response.deviation)) return [3 /*break*/, 4];
                normalizedDeviation = normalize(response.deviation, deviationSchema);
                return [4 /*yield*/, all([
                        put(createPollSuccessAction(normalizedDeviation)),
                        put(ModalActions.popModal()),
                    ])];
            case 2:
                _a.sent();
                return [4 /*yield*/, delay(400)];
            case 3:
                _a.sent();
                window.location.replace(getDeviationUrl(response.deviation));
                _a.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}
export function updatePollRequestSaga(action) {
    var payload, params, response, normalizedDeviation;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                params = {
                    pollid: payload.pollId,
                    question: payload.question,
                    answers: payload.answers,
                };
                return [4 /*yield*/, call(postRequest, '/poll/update', params)];
            case 1:
                response = _a.sent();
                if (!(response && response.deviation)) return [3 /*break*/, 3];
                normalizedDeviation = normalize(response.deviation, deviationSchema);
                return [4 /*yield*/, all([
                        put(updatePollSuccessAction(normalizedDeviation)),
                        put(editDeviationSuccess({ deviation: response.deviation })),
                        put(ModalActions.popModal()),
                    ])];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}
export default function pollsSagas() {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(updatePollRequestAction, updatePollRequestSaga),
                    takeEvery(createPollRequestAction, createPollRequestSaga),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=sagas.js.map